$(document).ready(function () {
  $('.header__menu-item').on('mouseenter focusin', function () {
    var $menuItem = $(this);
    var $megaLinks = $menuItem.closest('details').find('.mega-menu__link');

    var itemOffsetLeft = $menuItem.offset().left;
    var headerOffsetLeft = $('.header__inline-menu').offset().left; // Adjust this if needed

    var marginLeft = itemOffsetLeft - headerOffsetLeft;

    $megaLinks.css('margin-left', marginLeft + 'px');
  });
});

